// Middleware constants for pure Privy authentication
export const COOKIE_NAME = "mygeotokens_user";

// Public API routes that don't require authentication (Privy-only)
export const publicApiRoutes = [
	"/api/user/auth/privy-login", // Only Privy authentication endpoint
	"/api/user/auth/refresh", // Token refresh endpoint (accepts expired tokens)
	"/api/user/auth/merge-accounts", // Handles own auth via privyUserId fallback
	"/api/user/auth/wallet-merge-check", // Pre-flight wallet conflict check (no JWT needed)
	"/api/user/auth/email-merge-check",  // Pre-flight email conflict check (no JWT needed)

	// Custom Phantom Connection APIs (unauthenticated - part of registration/login flow)
	"/api/user/lookup/email", // Check if user exists by email (registration flow)
	"/api/user/lookup/wallet", // Check if user exists by wallet (registration flow)
	"/api/user/check-conflicts", // Conflict detection for registration flow
	"/api/user/phantom-connect", // Main Phantom connection endpoint (creates users/login)

	"/api/metadata/single",
	"/api/metadata/collection",
	"/api/map/fetch-nft",
	"/api/search",
	"/api/transfer-nfts",
	"/api/image-upload",
	"/api/wallet/balance", // Wallet balance endpoint
	"/api/rpc-proxy", // RPC proxy endpoint for blockchain calls
	"/api/rpc-proxy/health", // RPC proxy health check
	"/api/price/sol", // Solana price endpoint
	"/api/image-proxy", // Image optimization proxy (called by <Image> tags)
];

// Public page routes (no authentication required). Used by middleware: any
// other page path requires a valid session or the user is sent to `/`.
export const publicRoutes = [
	"/",
	"/about",
	"/faqs",
	"/privacy",
	"/terms",
	"/guide",
	"/snag-nft",
];

// Protected routes (require any authentication method) — informational;
// page access is enforced via `publicRoutes` (everything else needs auth).
export const protectedRoutes = [
	"/profile",
	"/wallet",
	"/drop-nft",
	"/transfer-cnfts",
];

// Admin routes (require admin role)
export const adminRoutes = ["/admin"];
